// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"fe63bd57","703":"c466059d","787":"6c4fe08c"}[chunkId] + ".chunk.js";
};